// Product
const Listproduct = () => import('@/views/product-management/index')
const Formproduct = () => import('@/views/product-management/form')

export default {
    path: 'product-management',
    redirect: '/product-management',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'product-management',
            component: Listproduct,
            meta: {
                link: 'product-management',
                breadcrumb: [
                    { title: 'Product Management', active: true },
                    { title: 'Product', active: true },
                ],
                pageTitle: 'Product'
            }
        },
        {
            path: 'add',
            name: 'addproduct',
            component: Formproduct,
            meta: {
                link: 'product-management',
                breadcrumb: [
                    { title: 'Product Management', active: true },
                    { title: 'Product', url: '/product-management' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Product'
            }
        },
        {
            path: 'edit/:id',
            name: 'editproduct',
            component: Formproduct,
            meta: {
                link: 'product-management',
                breadcrumb: [
                    { title: 'Product Management', active: true },
                    { title: 'Product', url: '/product-management' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Product'
            }
        },
    ]
}